<template>
    <div class="block-pram" :class="classes">
        <span class="block-pram__body"></span>
        <span class="block-pram__weel block-pram--weel-left"></span>
        <span class="block-pram__weel block-pram--weel-right"></span>
    </div>
</template>

<script>
export default {
    props: {
        iconColor: {
            type: String,
            default: 'white'
        },
        isScroll: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        classes () {
            return `block-pram--${this.iconColor}`
        }
    }
}
</script>

<style scoped lang="stylus">
    .block-pram {
        display: flex
        position: relative

        &__body {
            width 14.5rem
            height 15rem
            background-size contain
            background-repeat no-repeat
        }

        &__weel {
            width 40px
            height 40px
            background-size contain
            position: absolute
            animation-name rotate
            animation-duration 3s
            animation-timing-function linear
            animation-fill-mode backwards
            animation-iteration-count: infinite
            background-repeat no-repeat
        }

        &--weel-left {
            left 28px;
            bottom -12px;
        }

        &--weel-right {
            bottom 0
            right 18px
        }

        &--white {
            & ^[0]__body {
                background-image: url('~@/assets/images/icons/pram-tiny-white.png')
            }
            & ^[0]__weel {
                background-image: url('~@/assets/images/icons/weel-white.png')
            }
        }

        &--yellow {
            & ^[0]__body {
                background-image: url('~@/assets/images/icons/pram-tinny-yellow.png')
            }

            & ^[0]__weel {
                background-image: url('~@/assets/images/icons/weel-yellow.png')
            }

            & ^[0]--weel-left {
                left 8px
                bottom -10px

            }
        }

        &--blue {
            & ^[0]__body {
                background-image: url('~@/assets/images/icons/pram-tinny-blue.png')
            }
            & ^[0]__weel {
                background-image: url('~@/assets/images/icons/weel-blue.png')
            }
            & ^[0]--weel-left {
                left 10px
                bottom 24px

            }
            & ^[0]--weel-right {
                bottom 17px
                right 9px
            }
        }
    }

    @keyframes rotate  {
        0% {
            transform: rotate(0deg)
        }
        100% {
            transform rotate(360deg)
        }
    }
</style>
